import React, { Component } from 'react';

export default class Breakdown extends Component{
    toObject = (value) => {
        if (!value) {
            return null;
        }
        if (typeof value === 'object') {
            return value;
        }
        if (typeof value === 'string') {
            try {
                return JSON.parse(value);
            } catch (e) {
                return null;
            }
        }
        return null;
    }

    firstText = (values, fallback = '') => {
        for (let i = 0; i < values.length; i++) {
            const value = values[i];
            if (typeof value === 'string' && value.trim() !== '') {
                return value.trim();
            }
        }
        return fallback;
    }

    normalizeEntry = (element, index, eventMode) => {
        const properties = ((element && element.properties) ? element.properties : {});
        const business = this.toObject(properties.business);

        const eventTitle = this.firstText([
            properties.title,
            properties.name,
            properties.activity_name,
            properties.event_name
        ]);

        const placeTitle = this.firstText([
            properties.place_name,
            properties.placeName,
            properties.companyname,
            business && business.companyname,
            properties.venue,
            properties.location_name,
            properties.city,
            business && business.city
        ], 'Unnamed place');

        const primaryTitle = (eventMode && eventTitle !== '' ? eventTitle : placeTitle);
        const secondaryTitle = (eventMode ? placeTitle : '');

        return {
            index,
            primaryTitle,
            secondaryTitle
        };
    }

    render(){
        const { data, selectEvent, eventMode } =  this.props;
        const source = (Array.isArray(data) ? data : []);
        const entries = source.map((element, index) => this.normalizeEntry(element, index, eventMode));

        return (
            <div className={"BRL w-100 container_breakdown"}>
                <div className="breakdown_list">
                {entries.map((entry, i) =>{
                return (
                    <button key={"element_" + entry.index}
                        type="button"
                        className="BRL w-100 element_breakdown"
                        aria-label={"Open details for " + entry.primaryTitle}
                        onClick={() => {
                            selectEvent(entry.index);
                        }}>
                        <div className="breakdown_index">{i + 1}</div>
                        <div className="breakdown_text_wrap">
                            <div className="text_breakdown">{entry.primaryTitle}</div>
                            {entry.secondaryTitle !== '' && <div className="breakdown_meta">{entry.secondaryTitle}</div>}
                        </div>
                    </button>
                )})}
                </div>

            </div>
        );
    }

}
